import { Col, Menu, Row, Space } from "antd";
import { ExclamationCircleOutlined, SlidersOutlined, BranchesOutlined, GlobalOutlined, RiseOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router";
import { IAppDetails } from "../../types";
import { ItemType } from "antd/lib/menu/hooks/useItems";

const AppSettingsRoot = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("general");
    const { appDetails } = useOutletContext<{ appDetails: IAppDetails }>();

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[10] || "environment");
    }, [location.pathname]);

    return (
        <Row gutter={24}>
            <Col span={6}>
                <Menu
                    mode="inline"
                    className="ant-card-bordered"
                    selectedKeys={[activeTab]}
                    onSelect={(item) => {
                        navigate(item.key);
                        setActiveTab(item.key);
                    }}
                    items={[
                        {
                            key: "environment",
                            label: <Space>
                                <SlidersOutlined />
                                Environment Variables
                            </Space>
                        } as ItemType]
                        .concat(appDetails.pipelineId ? [
                            {
                                key: "git",
                                label: <Space>
                                    <BranchesOutlined />
                                    Git
                                </Space>
                            }
                        ] : [])
                        .concat([
                            {
                                key: "scaling",
                                label: <Space>
                                    <RiseOutlined />
                                    Scaling
                                </Space>
                            },
                            {
                                key: "domain",
                                label: <Space>
                                    <GlobalOutlined />
                                    Domain
                                </Space>,
                                disabled: appDetails.clusterType === "shared" || !!appDetails.associatedNamespace,
                                title: appDetails.clusterType === "shared" || !!appDetails.associatedNamespace ?
                                    `Domain configuration is not enabled for apps deployed on a ${appDetails.clusterType === "shared" ? "shared cluster" : "cluster with access limitation"}` :
                                    undefined
                            },
                            {
                                key: "danger-zone",
                                label: <Space>
                                    <ExclamationCircleOutlined />
                                    Danger Zone
                                </Space>,
                                danger: true
                            }
                        ])
                    }
                />
            </Col>
            <Col span={18}>
                <Outlet context={{ appDetails }} />
            </Col>
        </Row >
    );

}

export default AppSettingsRoot;